/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { UserManagement } from '@piwikpro/react-piwik-pro'
import { navigate } from 'gatsby'
import { getCurrentLang } from '@/helpers/getCurrentLang'
import { isBrowser } from '@/helpers/isBrowser'
import { renderHiddenFormInput } from '@/helpers/renderHiddenFormParam'
import { getUrl } from '@/helpers/getUrl'
import { getButtonStyle } from '@/components/atoms/Button/helpers'
import * as styles from './Button.module.css'

interface ButtonProps extends ButtonTypes {
  // eslint-disable-next-line react/require-default-props
  onClick?: (e: React.MouseEvent) => void
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean
  // eslint-disable-next-line react/require-default-props
  className?: string
  children: React.ReactNode
}

export function Button({
  children,
  outlined,
  type,
  disabled = false,
  className = '',
  theme,
  as_form,
  url,
  onClick,
  intercom_trigger,
  form_params,
  id,
  class: cmsClass,
  variant
}: ButtonProps) {
  const [visitorId, setVisitorId] = useState('')
  const lang = isBrowser() ? getCurrentLang(window.location) : process.env.GATSBY_DEFAULT_LANGUAGE

  const scrollInto = (elementId: string) => {
    const element = document.querySelector(elementId)
    element?.scrollIntoView()
  }

  const navigateToUrl = (link: Link) => {
    if (link.url.startsWith('#')) {
      scrollInto(link.url)
    } else {
      navigate(getUrl(link))
    }
  }

  const onClickHandler = () => {
    if (onClick) {
      return onClick
    }

    if (intercom_trigger && intercom_trigger?.value.length > 0) {
      const payload: (string | number)[] = intercom_trigger.value.map((item) =>
        // eslint-disable-next-line no-restricted-globals
        !isNaN(Number(item)) && item.trim() !== '' ? Number(item) : item
      )

      // @ts-ignore
      return () => window?.Intercom(...payload)
    }

    if (url && type !== 'submit') {
      return () => navigateToUrl(url)
    }

    return undefined
  }

  const newButtonStyles = getButtonStyle(variant, className, cmsClass)
  const oldButtonStyles = clsx(
    'btn font-bold py-12 px-12 lg:px-24 rounded border text-bodyL',
    theme === 'filled' &&
      'bg-primary-500 border-primary-500 text-white transition duration-200 ease-in hover:bg-primary-900 hover:border-bg-primary-900 text-bodyL',
    theme === 'transparent' && 'bg-transparent text-text-dark-900 text-bodyL px-16 border-transparent',
    theme === 'dark' &&
      'bg-black border-black text-white transition duration-200 ease-in hover:text-black hover:bg-white' +
        ' hover:border-white',
    theme === 'white' && clsx('bg-white border-white text-black-dark transition duration-200 ease-in', styles.white),
    outlined && styles.outlined,
    className,
    cmsClass
  )

  useEffect(() => {
    async function getVisitorId() {
      const visID = await UserManagement.getVisitorId()
      setVisitorId(visID || '')
    }
    if (as_form) {
      getVisitorId()
    }
  }, [])

  const buttonType = type === 'submit' ? 'submit' : 'button'

  const ButtonComponent = (
    <button
      disabled={disabled}
      className={variant ? newButtonStyles : oldButtonStyles}
      type={buttonType}
      onClick={!as_form ? onClickHandler() : undefined}
      {...(id ? { id } : {})}
    >
      {children}
    </button>
  )

  return !as_form ? (
    ButtonComponent
  ) : (
    <form method="GET" action={url?.url}>
      {ButtonComponent}
      <input className="hidden" name="lang" type="hidden" value={lang} />
      {visitorId ? <input className="hidden" name="pk_vid" type="hidden" value={visitorId} /> : null}
      {form_params?.map(renderHiddenFormInput)}
    </form>
  )
}
